module.exports = __webpack_public_path__ + "img/image-4B.f2afe524.jpg";